import { Button, FMButton } from '@own/fds-react';
import { useHistory } from 'react-router-dom';
import './vehicle-selector-button.scss';

export const OnboardingVehicleSelectorButton = ({
    lowercaseBrand,
    buttonText,
    className,
}: {
    lowercaseBrand: string;
    buttonText: string;
    className?: string;
}) => {
    const history = useHistory();
    const handleButtonClick = () => {
        history.push(`/discover-your-${lowercaseBrand}/vehicle-selector`);
    };

    return (
        <div
            className={`billboard-vehicle-selector-button ${
                className ? className : ''
            }`}
        >
            {lowercaseBrand === 'ford' && (
                <FMButton
                    type="tertiary"
                    label={buttonText}
                    chevron={'right'}
                    onClick={handleButtonClick}
                    data-testid={'vehicle-selector-button'}
                />
            )}

            {lowercaseBrand === 'lincoln' && (
                <Button
                    type="text"
                    label={buttonText}
                    chevron={'right'}
                    onClick={handleButtonClick}
                    data-testid={'vehicle-selector-button'}
                />
            )}
        </div>
    );
};
